module.exports = require("@material/textfield/dist/mdc.textfield");


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/textfield/dist/mdc.textfield","commonjs2":"@material/textfield/dist/mdc.textfield","commonjs":"@material/textfield/dist/mdc.textfield","amd":"@material/textfield/dist/mdc.textfield","umd":"@material/textfield/dist/mdc.textfield"}
// module id = 54
// module chunks = 0